import { makeStyles } from "@material-ui/core";
import Autocomplete from "react-google-autocomplete";

const useStyles = makeStyles(() => ({
  root: {
    display: "block",
    border: "none",
    backgroundColor: "transparent",
    "&:focus-visible": {
      outline: "none",
    },
    width: "100%",
  },
}));

export const AddressAutoComplete = ({
  cssStyle,
  value,
  defaultValue,
  onSeleted,
  onChange,
  disabled,
  onBlur,
}) => {
  const classes = useStyles();
  return (
    <Autocomplete
      defaultValue={defaultValue}
      disabled={disabled}
      value={value || ""}
      apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
      className={cssStyle ? cssStyle : classes.root}
      placeholder=""
      onPlaceSelected={onSeleted}
      onBlur={onBlur}
      onChange={(e) => onChange(e.target.value)}
      options={{
        types: ["address"],
      }}
    />
  );
};
